import { useLazyQuery } from "@apollo/client";
import { useCallback, useEffect, useState } from "react";
import ContentViewModal from "../../components/ContentViewModal";
import CustomButton from "../../components/layout/CustomButton";
import Loader from "../../components/layout/Loader";
import NoDataFound from "../../components/layout/NoDataFound";
import TableComponent from "../../components/layout/TableComponent";
import { ICSVContactImportsData } from "../../interfaces";
import { ADMIN_IMPORTS_HEADER, CONTACT_IMPORTS_HEADER, PAGE_LIMIT } from "../../utils/constant";
import ModalUpload from "./ModalUpload";
import { LIST_DATA_CSV_CONTACT_IMPORTS} from "./gql";
import EmailModal from "./EmailModal";
import { CONTACT_IMPORTS } from "../../constants";
import { mapListData } from "./mapListData";
import CSVTablePagination from "./csvTablePagination";

const ContactImport = ({ adminImport }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [isOpenErrorModal, setIsOpenErrorModal] = useState<boolean>(false)
  const [ErrorMessage, setErrorMessage] = useState<string>()
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [fileName, setFileName] = useState<string>('')
  const [showEmailModal, setShowEmailModal] = useState<boolean>(false)
  const [selectedFileId, setSelectedFileId] = useState<string | null>(null);
  const [listDataCSVContactImports, { data: listData, loading: listLoading, refetch }] = useLazyQuery(LIST_DATA_CSV_CONTACT_IMPORTS);

  const listCSVContactImports = useCallback(async () => {
    if (fileName === '') {
      await listDataCSVContactImports({
        variables: {
          adminImport,
          limit,
          fileName: '',
          page: currentPage,
        },
      });
    }
  }, [currentPage, limit, fileName, listDataCSVContactImports]);

  const closeEmailModal = () => {
    setShowEmailModal(false);
    setSelectedFileId(null);
  }

  useEffect(() => {
    listCSVContactImports();
  }, [listCSVContactImports]);


  return (
    <>
      <h5 className="m-0 mb-4">{CONTACT_IMPORTS}</h5>
      <div className="search-filter primaryHeaderSpacing"  style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <div className="filter-status">
          <div className="filter-by">
            <CustomButton className="ml-auto" buttonText="Import Contacts"
              buttonClick={() => setIsOpen(!isOpen)}
            />
          </div>
        </div>
      </div>

      <div className="table-responsive">
        <TableComponent tableHeader={adminImport ? ADMIN_IMPORTS_HEADER : CONTACT_IMPORTS_HEADER}>
          <tbody>
            {listLoading && (
              <td colSpan={14}>
                <Loader loaderClass="sm-height " />
              </td>
            )}
            {!listLoading && !listData?.listDataCsvContactImport?.dataCsvContactImports?.length && (
              <td colSpan={14} className="empty-table-td">
                <NoDataFound text="No Record Found!" />
              </td>
            )}
            {!listLoading && listData?.listDataCsvContactImport?.dataCsvContactImports?.map((item: ICSVContactImportsData, index: number) => {
              return <tr key={index}>{mapListData({data: item,
                adminImport,
                isContactImport: true,
                setErrorMessage,
                setIsOpenErrorModal,
                refetch,
                setSelectedFileId,
                setShowEmailModal
              })}</tr>
            })}
          </tbody>
        </TableComponent>
      </div >

      {!listLoading && !!listData?.listDataCsvContactImport?.dataCsvContactImports?.length &&
        <CSVTablePagination
          currentPage={currentPage}
          totalCount={listData?.listDataCsvContactImport?.count}
          limit={limit}
          pageLimitOptions={PAGE_LIMIT}
          onPageChange={setCurrentPage}
          onLimitChange={(newLimit) => {
            setCurrentPage(1);
            setLimit(newLimit);
          }}
        />
      }

      <ModalUpload isOpen={isOpen} refetch={refetch} toggle={() => setIsOpen(!isOpen)} adminImport={adminImport} isContactImport={true} />
      <ContentViewModal isOpen={isOpenErrorModal} heading={"Error Message"} toggle={() => setIsOpenErrorModal(!isOpenErrorModal)}
        content={ErrorMessage}
      />
      <EmailModal isOpen={showEmailModal} toggle={closeEmailModal} fileId={selectedFileId}/>
    </>
  )
}

export default ContactImport